import React, { Component } from 'react';
import { connect } from 'react-redux';

import { templateMngService } from '../../services';
import { alertActions } from '../../modules/alert';
import './opbpreview.css';

class OpbSection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            backgroundImage: null,
        };

        if (props.opbInfo.themeID > 0) {
            this.setBackgroundImage(props.opbInfo.themeID);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.opbInfo.templateID !== this.props.opbInfo.templateID ||
            prevProps.opbInfo.themeID !== this.props.opbInfo.themeID) {
            this.setBackgroundImage(this.props.opbInfo.themeID);
        }
    }

    setBackgroundImage = (themeID) => {
        templateMngService.downloadFile('theme', themeID)
            .then(response => {
                if (response.data) {
                    this.setState({
                        backgroundImage: "url(data:image/jpeg;base64," + Buffer.from(response.data, 'binary').toString('base64') + ")",
                    });
                }
            })
            .catch(this.handleErrors);
    };

    handleErrors = (error) => {
        console.log(error.toString());
        if (error.response === undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else {
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    };

    handleSelectedContents = (value) => {
        this.props.handleSelectedContents(value);
    };


    render() {
        const { opbInfo, isMobile, selectedContents } = this.props;

        return (
            <div className="opbsection">
                {!isMobile &&
                <div className="opbsection-title">
                    <div>영역선택</div>
                </div>
                }
                <div className={`opbsection-pannel`} style={{ backgroundImage: this.state.backgroundImage, backgroundRepeat: "no-repeat", backgroundSize: "100% 100%" }}>
                    <div className={`clock-widget clock-style-${opbInfo && opbInfo.templateID}`}>
                    </div>
                    <div id='promotion-widget' className={`promotion-widget promotion-style-${opbInfo && opbInfo.templateID}${selectedContents === "CT002" ? " active" : ""}`} >
                        <div className="setting-button" onClick={() => this.props.handleSelectedContents("CT002")}>
                            <div className="setting-button-icon">
                                <img style={{ height: "100%" }} src={`/assets/images/screenMod/ic-edit-${selectedContents === "CT002" ? "y" : "w"}.svg`} alt="편집아이콘" />
                            </div>
                            <div className={`setting-button-title${selectedContents === "CT002" ? " active" : ""}`}>영상편집 (상단)</div>
                        </div>
                    </div>
                    <div className={`goingfloors-widget goingfloors-style-${opbInfo && opbInfo.templateID}`}>
                    </div>
                    <div id='marketing-widget' className={`marketing-widget marketing-style-${opbInfo && opbInfo.templateID}${selectedContents === "CT003" ? " active" : ""}`} >
                        <div className="setting-button" onClick={() => this.props.handleSelectedContents("CT003")}>
                            <div className="setting-button-icon">
                                <img style={{ height: "100%" }} src={`/assets/images/screenMod/ic-edit-${selectedContents === "CT003" ? "y" : "w"}.svg`} alt="편집아이콘" />
                            </div>
                            <div className={`setting-button-title${selectedContents === "CT003" ? " active" : ""}`}>영상편집 (중앙)</div>
                        </div>
                    </div>
                    <div className={`news-widget news-style-${opbInfo && opbInfo.templateID}`}>
                    </div>
                    <div id='bottom-widget' className={`bottom-widget bottom-style-${opbInfo && opbInfo.templateID}${selectedContents === "CT004" ? " active" : ""}`} >
                        <div className="setting-button" onClick={() => this.props.handleSelectedContents("CT004")}>
                            <div className="setting-button-icon">
                                <img style={{ height: "100%" }} src={`/assets/images/screenMod/ic-edit-${selectedContents === "CT004" ? "y" : "w"}.svg`} alt="편집아이콘" />
                            </div>
                            <div className={`setting-button-title${selectedContents === "CT004" ? " active" : ""}`}>영상편집 (하단)</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(OpbSection);